interface RefreshAlertProps {
   onRefresh: () => void
   isFetching: boolean
   message?: string
   variant?: "info" | "warning"
   buttonText?: string
}

export function RefreshAlert({
   onRefresh,
   isFetching,
   message = "De nouvelles données sont disponibles",
   variant = "info",
   buttonText = "Actualiser",
}: RefreshAlertProps) {
   return (
      <div className="toast toast-bottom toast-center">
         <div
            role="alert"
            className={`alert ${variant === "warning" ? "alert-warning" : "alert-info"} shadow-lg`}
         >
            {variant === "warning" ? (
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  className="stroke-current shrink-0 w-6 h-6"
               >
                  <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth="2"
                     d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
               </svg>
            ) : (
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  className="stroke-current shrink-0 w-6 h-6"
               >
                  <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth="2"
                     d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
               </svg>
            )}
            <span>{message}</span>
            <button
               onClick={onRefresh}
               className={`btn btn-sm ${variant === "warning" ? "btn-warning" : "btn-primary"}`}
               disabled={isFetching}
            >
               {isFetching ? "Actualisation..." : buttonText}
            </button>
         </div>
      </div>
   )
}
